import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Newspaper, CalendarDays, GraduationCap, ArrowUpRight } from "lucide-react";

export default function ComingSoon() {
    return (
        <section
            id="comingsoon-section"
            data-testid="comingsoon-section"
            className="relative mx-auto w-full max-w-6xl scroll-mt-20 overflow-visible px-6 py-24 sm:py-32"
        >
            <span
                aria-hidden="true"
                className="pointer-events-none absolute -top-2 right-2 select-none font-serif text-[9rem] leading-none text-amber-500/[0.06] sm:text-[13rem]"
            >
                —
            </span>
            <motion.div
                initial={{ opacity: 0, y: 36 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6 }}
            >
                <div className="flex items-baseline gap-4">
                    <span className="font-serif text-sm tracking-[0.35em] text-amber-500">
                        —
                    </span>
                    <span className="h-px flex-1 bg-amber-500/20" aria-hidden="true" />
                    <span className="text-xs uppercase tracking-[0.3em] text-amber-200/50">
                        From the Practice
                    </span>
                </div>
                <h2 className="mt-6 font-serif text-2xl tracking-tight text-amber-50 sm:text-3xl lg:text-4xl">
                    On the horizon — and one door already open
                </h2>
            </motion.div>

            <div className="mt-12 grid gap-5 sm:grid-cols-3">
                <Link
                    to="/blog"
                    data-testid="comingsoon-blog-card"
                    className="block rounded-2xl border border-amber-500/25 bg-[#1F1510]/50 p-7 transition-[border-color,transform] duration-300 hover:-translate-y-1 hover:border-amber-400/60"
                >
                    <span className="flex h-10 w-10 items-center justify-center rounded-full bg-amber-500/10 ring-1 ring-amber-500/25">
                        <Newspaper className="h-5 w-5 text-amber-400" />
                    </span>
                    <h3 className="mt-5 font-serif text-lg text-amber-100">Blog</h3>
                    <p className="mt-2 text-sm leading-relaxed text-amber-100/55">
                        Notes from the practice on play, feelings, and family
                        life.
                    </p>
                    <p className="mt-5 inline-flex items-center gap-1.5 text-sm font-semibold text-amber-300">
                        Read the notes
                        <ArrowUpRight className="h-4 w-4" />
                    </p>
                </Link>

                <Link
                    to="/events"
                    data-testid="comingsoon-events-card"
                    className="block rounded-2xl border border-amber-500/25 bg-[#1F1510]/50 p-7 transition-[border-color,transform] duration-300 hover:-translate-y-1 hover:border-amber-400/60"
                >
                    <span className="flex h-10 w-10 items-center justify-center rounded-full bg-amber-500/10 ring-1 ring-amber-500/25">
                        <CalendarDays className="h-5 w-5 text-amber-400" />
                    </span>
                    <h3 className="mt-5 font-serif text-lg text-amber-100">
                        Events
                    </h3>
                    <p className="mt-2 text-sm leading-relaxed text-amber-100/55">
                        Story times, parent nights, and community gatherings.
                    </p>
                    <p className="mt-5 inline-flex items-center gap-1.5 text-sm font-semibold text-amber-300">
                        See what's coming
                        <ArrowUpRight className="h-4 w-4" />
                    </p>
                </Link>

                <Link
                    to="/trainings"
                    data-testid="comingsoon-ce-card"
                    className="block rounded-2xl border border-amber-500/45 bg-[#281D17] p-7 shadow-[0_20px_60px_rgba(245,158,11,0.08)] transition-[border-color,transform] duration-300 hover:-translate-y-1 hover:border-amber-400/70"
                >
                    <span className="flex h-10 w-10 items-center justify-center rounded-full bg-amber-500/20 ring-1 ring-amber-500/50">
                        <GraduationCap className="h-5 w-5 text-amber-400" />
                    </span>
                    <h3 className="mt-5 font-serif text-lg text-amber-100">
                        CE Hours & Trainings
                    </h3>
                    <p className="mt-2 text-sm leading-relaxed text-amber-100/55">
                        APT- and EMDRIA-approved continuing education for
                        therapists, led by an RPT-S.
                    </p>
                    <p className="mt-5 inline-flex items-center gap-1.5 text-sm font-semibold text-amber-300">
                        Now booking
                        <ArrowUpRight className="h-4 w-4" />
                    </p>
                </Link>
            </div>
        </section>
    );
}
